import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ReadsHero() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const stripRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/media/reads_hero").then(r => setItems(r.data || [])).catch(()=>{});
  }, []);

  if (!items.length) return null;

  const go = (delta) => setIdx((idx + delta + items.length) % items.length);
  const cur = items[idx];

  const open = () => {
    if (cur.link?.startsWith("/")) navigate(cur.link);
    else if (cur.link) window.open(cur.link, "_blank");
  };

  return (
    <div className="lt-reads-hero" data-testid="reads-hero">
      <div className="lt-reads-feature" onClick={open} style={{backgroundImage:`url("${cur.image_url}")`}}>
        <div className="lt-reads-shade" />
        <div className="lt-reads-feature-content">
          <div className="lt-reads-eyebrow">{cur.title || "Featured"}</div>
          <div className="lt-reads-feature-title">{cur.subtitle || ""}</div>
          <div className="lt-reads-cta">Read article →</div>
        </div>
        {items.length > 1 && (
          <>
            <button className="lt-hero-nav prev" data-testid="reads-prev" onClick={(e)=>{e.stopPropagation(); go(-1);}}>‹</button>
            <button className="lt-hero-nav next" data-testid="reads-next" onClick={(e)=>{e.stopPropagation(); go(1);}}>›</button>
          </>
        )}
      </div>
      {items.length > 1 && (
        <div className="lt-reads-strip" ref={stripRef}>
          {items.map((m, i) => (
            <div key={m.id || i}
                 className={`lt-reads-thumb ${i===idx?"on":""}`}
                 style={{backgroundImage:`url("${m.image_url}")`}}
                 onClick={()=>setIdx(i)}>
              <div className="lt-reads-thumb-meta">
                <div className="lt-reads-thumb-eyebrow">{m.title}</div>
                <div className="lt-reads-thumb-title">{m.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
